<template>
  <div>
    <v-row no-gutters>
      <v-col cols="1">
        <v-icon x-large>mdi-account-circle</v-icon>
      </v-col>
      <v-col cols="11">
        <v-row no-gutters>
          <h4>{{ distribution.autor }}</h4>
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                large
                v-on="on"
                v-if="distribution.isViewed"
                icon
                color="success"
                >mdi-file-eye-outline</v-icon
              >
            </template>
            <span>{{ $t("Visualized") }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                large
                v-if="!distribution.isViewed"
                icon
                color="error"
                >mdi-file-eye-outline</v-icon
              >
            </template>
            <span>{{ $t("PendingVisualization") }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                large
                v-if="
                  distribution.requiresValidation && distribution.isValidated
                "
                icon
                color="success"
                >mdi-file-check-outline</v-icon
              >
            </template>
            <span>{{ $t("Validated") }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                large
                v-if="
                  distribution.requiresValidation && distribution.isRejected
                "
                icon
                color="error"
                >mdi-file-remove-outline</v-icon
              >
            </template>
            <span>{{ $t("Rejected") }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                large
                v-if="
                  distribution.requiresValidation && !distribution.isValidated && !distribution.isRejected
                "
                icon
                color="error"
                >mdi-file-check-outline</v-icon
              >
            </template>
            <span>{{ $t("PendingValidation") }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                large
                v-if="distribution.requiresSignature && distribution.isSigned"
                icon
                color="success"
                >mdi-draw</v-icon
              >
            </template>
            <span>{{ $t("Signed") }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                large
                v-if="distribution.requiresSignature && !distribution.isSigned"
                icon
                color="error"
                >mdi-draw</v-icon
              >
            </template>
            <span>{{ $t("PendingSignature") }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                large
                v-if="distribution.isExpired"
                icon
                color="error"
                >mdi-calendar-alert</v-icon
              >
            </template>
            <span>{{ $t("Expired") }}</span>
          </v-tooltip>
        </v-row>
        <v-row no-gutters v-if="distribution.dueDate">
          <span>{{ `${$t("ExpiresOn")}: ${distribution.dueDate}` }}</span>
        </v-row>
      </v-col>
    </v-row>
    <v-divider class="my-2"></v-divider>
  </div>
</template>
<script>
export default {
  props: {
    distribution: {
      type: Object,
    },
  },
};
</script>